var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$locale['main-banner-title'])?_c('main',{staticClass:"main-container"},[_c('MainBanner'),_c('HomeWork'),_c('HomeCarousel'),_c('HomeText'),_c('HomeProjects'),_c('HomeInfoBanner'),_c('HomeCardsSlider')],1):_c('Spinner')
}
var staticRenderFns = []

export { render, staticRenderFns }